<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Edit Package</h1>
      </div>
    </div>
    <b-card class="mt-3">
      <b-row>
        <b-col md="6" offset-md="3">
          <div v-if="loading" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
          <b-alert v-else-if="error" class="text-center" variant="danger" show>
            <p>Something went wrong...</p>
            <strong>error</strong>
            <router-link class="btn btn-primary" :to="{ name: 'packages' }">
              Back to Packages
            </router-link>
          </b-alert>
          <package-form
            v-else
            :package="_package"
            :saving="saving"
            @submit="submit"
          ></package-form>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PackageForm from './PackageForm';

export default {
  components: {
    PackageForm
  },
  methods: {
    ...mapActions({
      fetchPackage: 'packages/fetchPackage',
      updatePackage: 'packages/updatePackage'
    }),
    async submit(_package) {
      try {
        this.saving = true;
        await this.updatePackage(_package);
        this.$notify({
          type: 'success',
          text: 'Package updated'
        });
        this.$router.push({ name: 'packages' });
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      } finally {
        this.saving = false;
      }
    }
  },
  computed: {
    _package() {
      return this.$store.getters['packages/packageById'](this.$route.params.id);
    }
  },
  data() {
    return {
      loading: true,
      saving: false,
      error: null
    };
  },
  async created() {
    const { id } = this.$route.params;

    if (!id) {
      this.$router.push({ name: 'packages' });
    }

    try {
      if (!this.package) {
        await this.fetchPackage(id);
      }
    } catch (e) {
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  }
};
</script>
